import styles from './NotificationElement.module.css';

const NotificationElement = (props) => {

  return (
    <div
      className={`${styles.container} d-flex flex-column justify-content-between align-items-center`}
    >
      <h4 className="text-dark text-center">{props.message}</h4>
      <div className={styles.image}></div>
    </div>
  );
}

export default NotificationElement;